<template>
  <form>
    <div class="row">
      <div style="width: 50%;" class="pl-2 pr-2">
        <div class="form-group">
          <label for="prodpicture" class="form-label">Product Picture:</label>
          (Enlarged pic name = *_lg.jpg)
          <input
            type="text"
            class="form-control"
            name="prodpicture"
            v-model="product.productsParent.imageurl"
          />
        </div>

        <div class="form-group">
          <label for="prodname" class="form-label">Product Name:</label>
          <input
            type="text"
            class="form-control"
            name="prodname"
            v-model="product.productsParent.name"
          />
        </div>

        <div class="form-group">
          <label for="prodname" class="form-label">Category:</label>
          <select
            class="form-control"
            v-model="product.productsParent.HID1"
            @change="getCategoryOne($event)"
          >
            <!-- <option value="">--Select--</option> -->
            <option
              v-for="category in allCategory"
              :key="category.id"
              :value="category.hid"
            >
              {{ category.label }} <span v-if="category.notes"> ({{ category.notes }})</span>
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="prodname" class="form-label">Subcategory 1:</label>
          <select
            class="form-control"
            v-model="product.productsParent.HID2"
            @change="getCategoryTwo($event)"
          >
            <!-- <option value="">--Select--</option> -->

            <option
              v-for="category in allCategoryOne"
              :key="category.id"
              :value="category.hid"
            >
              {{ category.label }} <span v-if="category.notes"> ({{ category.notes }})</span>
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="prodname" class="form-label">Subcategory 2:</label>
          <select v-model="product.productsParent.HID3" class="form-control">
            <!-- <option value="">--Select--</option> -->
            <option
              v-for="category in allCategoryTwo"
              :key="category.id"
              :value="category.hid"
            >
              {{ category.label }} <span v-if="category.notes"> ({{ category.notes }})</span>
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="proddesc" class="form-label">Product Description:</label>
          <textarea
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="13"
            v-model="product.productsParent.description"
          ></textarea>
        </div>

        <div class="form-group">
          <label for="manufacturer" class="form-label">Manufacturer:</label>
          <input
            type="text"
            class="form-control"
            name="manufacturer"
            v-model="product.productsParent.manufacturername"
          />
        </div>

        <div class="form-group">
          <label for="brand" class="form-label">Brand:</label>
          <input
            type="text"
            class="form-control"
            name="brand"
            v-model="product.productsParent.brand"
          />
        </div>

        <div class="form-group">
          <label for="brandKey" class="form-label">Tango Brand Key:</label>
          <input
            type="text"
            class="form-control"
            name="brandKey"
            v-model="product.productsParent.brandKey"
          />
        </div>

        <div class="form-group">
          <label for="supplier" class="form-label">Supplier:</label>
          <select
            class="form-control"
            aria-label="Default select example"
            v-model="product.productsParent.supplierid"
          >
            <option
              v-for="supplier in this.allSuppliers.Result"
              :key="supplier.id"
              :value="supplier.id"
            >
              {{ supplier.name }}
            </option>
          </select>
        </div>
      </div>
      <div style="width: 50%;" class="pl-2 pr-2">
        <div class="form-group">
          <label class="form-check-label" for="flexSwitchCheckDefault"
            >What's hot product:</label
          >
          <div class="form-switch mt-1">
            <b-form-checkbox
              v-model="product.productsParent.whatshot"
              :value="true"
              :unchecked-value="false"
            />
          </div>
        </div>

        <div
          class="form-group mt-2 mb-4"
          id="whatsHotInfo"
          v-if="product.productsParent.whatshot"
        >
          <label for="whList">Display this what's hot item to:</label>
          <select
            v-model="product.productsParent.whatsHotClientIDs"
            id="whList"
            class="form-control"
            size="10"
            name="whList"
            :multiple="true"
            :close-on-select="false"
          >
            <option
              v-for="client in allClients"
              :key="client.id"
              :value="client.id"
            >
              {{ client.name }}
            </option>
          </select>

          <br />
          <div class="d-flex" style="justify-content: center;">
            <div class="btn-grp">
              <input
                class="btn btn-primary btn-sm"
                value="Select All"
                @click="selectAll"
              />
            </div>
            <div class="btn-grp" style="margin-left: 10px">
              <input
                class="btn btn-primary btn-sm"
                value="Deselect All"
                @click="deSelectAll"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />
    <div class="table-responsive">
      <table class="table border table-responsive table-striped">
        <thead>
          <tr>
            <th scope="col">Supplier SKU</th>
            <th scope="col">Wholesale cost</th>
            <th scope="col">Shipping cost</th>

            <!-- Show only Size when supplierID = 316 -->
            <th v-if="product.productsParent.supplierid == 316" scope="col">Size</th>

            <!-- Show all these only when supplierID ≠ 316 -->
            <template v-if="product.productsParent.supplierid != 316">
              <th scope="col">Color</th>
              <th scope="col">Size</th>
              <th scope="col">Location</th>
              <th scope="col">Cover</th>
            </template>

            <th scope="col"></th>
          </tr>
        </thead>
        <tbody id="productChildren">
          <tr v-for="(content, index) in product.productsChildren" :key="index">
            <input
              type="hidden"
              class="productChildID form-control input-sm"
              name="ProductChildID|1"
              value="0"
            />
            <td>
              <input
                v-model="content.distributersku"
                type="text"
                class="productChildSupplierSKU form-control input-sm"
                name="ProductChildSupplierSKU|1"
              />
            </td>
            <td>
              <input
                type="number"
                class="productChildPrice form-control input-sm"
                name="ProductChildPrice|1"
                placeholder="0.00"
                v-model.number="content.price"
              />
            </td>
            <td>
              <input
                type="number"
                class="productChildShippingPrice form-control input-sm"
                name="ProductChildShippingPrice|1"
                placeholder="0.00"
                v-model.number="content.shippingcost"
              />
            </td>

            <!-- Show Color, Location, and Cover only when supplierid != 316 -->
            <td v-if="product.productsParent.supplierid != 316">
              <input
                type="text"
                name="ProductChildColor|1"
                class="form-control input-sm"
                v-model="content.color"
              />
            </td>

            <!-- Always show Size -->
            <td>
              <input
                type="text"
                name="ProductChildSize|1"
                class="form-control input-sm"
                v-model="content.size"
              />
            </td>

            <td v-if="product.productsParent.supplierid != 316">
              <input
                type="text"
                name="ProductChildLocation|1"
                class="form-control input-sm"
                v-model="content.location"
              />
            </td>

            <td v-if="product.productsParent.supplierid != 316">
              <input
                type="text"
                name="ProductChildCover|1"
                class="form-control input-sm"
                v-model="content.cover"
              />
            </td>

            <td>
              <input
                type="button"
                value="Add additional"
                id="btnAddAdditionalProductChildren"
                class="btn btn-primary btn-sm"
                @click="addTableRow()"
                v-show="index === product.productsChildren.length - 1"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col">
        <input
          type="button"
          class="btn btn-primary"
          value="Add Product"
          @click="onSubmit"
        />
      </div>
    </div>
  </form>
</template>
<script>
export default {
  name: "AddNewProductForm",
  data() {
    return {
      allClients: [],
      product: {
        productsParent: {
          brand: "",
          brandKey: "",
          name: "",
          description: "",
          featuredescription: "",
          imageurl: "",
          manufacturername: "",
          whatshot: false,
          exclude: false,
          supplierid: null,
          addedbyadminuserid: null,
          HID1: "",
          HID2: "",
          HID3: "",
          whatsHotClientIDs: [],
        },
        productsChildren: [
          {
            price: null,
            weight: null,
            shippingcost: null,
            distributersku: "",
            addedbyadminuserid: null,
            color: null,
            size: null,
            location: null,
            cover: null,
            productChildSpecifications: [],
          },
        ],
      },

      // tableRows: [
      //   {
      //     SupplierSKU: "",
      //     WholesaleCost: "",
      //     ShippingCost: "",
      //     Color: "",
      //     Size: "",
      //     Location: "",
      //     Cover: "",
      //   },
      // ],
      counter: 1,
      // selected: [],
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      console.log(this.product);

      // check
      if (this.product.productsParent.imageurl === "") {
        console.log(this.product.productsParent.imageurl);
        alert("Please fill 'Product Picture' field.");
        return;
      } else if (this.product.productsParent.name === "") {
        alert("Please fill 'Product Name' field.");
        return;
      } else if (this.product.productsParent.HID1 === "") {
        alert("Please fill 'Category' field.");
        return;
      }
      // else if (this.product.productsParent.HID2 === "") {
      //   alert("Please fill 'Subcategory 1' field.");
      //   return;
      // }
      // else if (this.product.productsParent.HID3 === "") {
      //   alert("Please fill 'Subcategory 2' field.");
      //   return;
      // }
      else if (this.product.productsParent.description === "") {
        alert("Please fill 'Product Description' field.");
        return;
      } else if (this.product.productsParent.manufacturername === "") {
        alert("Please fill 'Manufacturer' field.");
        return;
      } else if (this.product.productsParent.brand === "") {
        alert("Please fill 'Brand' field.");
        return;
      } else if (this.product.productsParent.supplierid === null) {
        alert("Please fill 'Supplier' field.");
        return;
      } else if (this.product.productsChildren[0].distributersku === "") {
        alert(
          "There was an error in the form. \n At least one supplier SKU is required."
        );
        return;
      } else if (this.product.productsChildren[0].price === null) {
        alert(
          "There was an error in the form. \n At least one Wholesale cost is required."
        );
        return;
      } else if (this.product.productsChildren[0].shippingcost === null) {
        alert(
          "There was an error in the form. \n At least one Shipping cost is required."
        );
        return;
      } else if (
        this.product.productsParent.supplierid === 316 &&
        (!this.product.productsParent.brandKey ||
          this.product.productsParent.brandKey.trim() === "")
      ) {
        alert("Please fill 'Brand Key' field (required for this supplier).");
        return;
      }

      // update
      this.product.productsParent.addedbyadminuserid = this.userId;
      this.product.productsChildren[0].addedbyadminuserid = this.userId;

      // Transform size into productChildSpecifications
      this.product.productsChildren = this.product.productsChildren.map((child) => {
        const newChild = { ...child };

        newChild.productChildSpecifications = [];

        if (child.size) {
          newChild.productChildSpecifications.push({
            specKey: "Size",
            specValue: child.size,
          });
        }

        delete newChild.size;
        return newChild;
      });

      this.$store
        .dispatch("manageProducts/addProduct", this.product)
        .then((data) => {
          console.log(data);
          this.$router.push({
            name: "EditProduct",
            params: { Id: `${data}` },
          });
        });
    },
    //select all options in the select
    selectAll() {
      this.product.productsParent.whatsHotClientIDs = this.allClients.map(
        (client) => client.id
      );
    },
    //deselect all options in the select
    deSelectAll() {
      this.product.productsParent.whatsHotClientIDs = [];
    },
    //add a new row to the table
    addTableRow() {
      this.counter++;
      this.product.productsChildren.push({
        price: null,
        weight: null,
        shippingcost: null,
        distributersku: "",
        addedbyadminuserid: this.userId,
        color: null,
        size: null,
        location: null,
        cover: null,
        productChildSpecifications: [],
      });
    },

    getCategoryOne(e) {
      console.log(e.target.value);
      this.$store.commit("divvyCategory/SET_CATEGORIES_ONE", []);
      this.$store.commit("divvyCategory/SET_CATEGORIES_TWO", []);
      this.$store.dispatch("divvyCategory/fetchSubCategoriesOne", {
        categoryID: e.target.value,
      });
    },
    getCategoryTwo(e) {
      console.log(e.target.value);
      this.$store.dispatch("divvyCategory/fetchSubCategoriesTwo", {
        categoryID: e.target.value,
      });
    },
  },
  computed: {
    allSuppliers() {
      return this.$store.getters["manageSuppliers/allSuppliers"];
    },
    allCategory() {
      return this.$store.getters["divvyCategory/allCategories"];
    },
    allCategoryOne() {
      return this.$store.getters["divvyCategory/allCategoriesOne"];
    },
    allCategoryTwo() {
      return this.$store.getters["divvyCategory/allCategoriesTwo"];
    },
    userId() {
      return this.$store.state.user.profile.id;
    },
  },
  mounted() {
    this.$store.dispatch("divvyCategory/fetchCategories", {
      categoryID: "/",
    });
    this.$store.dispatch("manageSuppliers/fetchAllSuppliers", {
      searchTerm: "",
      pageNumber: 1,
      pageSize: -1,
      sortField: "[NAME]",
      sortOrder: "ASC",
    });

    this.$store.dispatch("manageClients/getClients").then((clients) => {
      this.allClients = clients;
    });
  },
};
</script>
<style scoped>
form {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

.form-group {
  margin-bottom: 15px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.btn-grp {
  display: inline-block;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  border-spacing: 0;
  border-collapse: collapse;
}

.table-bordered {
  border: 1px solid #ddd;
}

.small {
  font-size: 85%;
}

.table > thead > tr > th {
  background: #ddd;
}

.table > :not(:first-child) {
  border-top: 0px;
}

.table > tbody {
  vertical-align: inherit;
}
</style>
